export const search = "search";
export const text = "text";
export const textNoIcon = "textNoIcon";
export const textNoIconShort = "textNoIconShort";